import { TouchpointBuilderTabForm } from "containers/admin/clients/touchpoint/components/email-builder/email-builder";
import { TextArea, type TextAreaProps } from "ui/text-area";
import { FormProps } from "ui/forms";

interface BuilderHtmlPreviewProps extends FormProps {
  value?: string;
  textareaTestId?: string;
  textareaProps?: Omit<TextAreaProps, "value">;
}
export const BuilderHtmlPreview = ({
  value = "",
  textareaTestId,
  textareaProps = {},
  ...rest
}: BuilderHtmlPreviewProps) => {
  return (
    // Probably don't need this to be a Form. Could just be Box.
    <TouchpointBuilderTabForm {...rest}>
      <TextArea
        data-testid={textareaTestId}
        controlSx={(theme) => ({ backgroundColor: theme.palette.common.white })}
        readOnly
        rows={25}
        value={value}
        {...textareaProps}
        resize="vertical"
      />
    </TouchpointBuilderTabForm>
  );
};
